import { Alert, CloseButton, Link, Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { apos } from 'lib/html-entities';

function ChartsLoadingErrorAlert() {
  const {
    isOpen: isVisible,
    onClose,
  } = useDisclosure({ defaultIsOpen: true });

  return isVisible ? (
    <Alert status="warning" mb={ 4 }>
      <Text mr={ 2 }>
        { `部分图表未能加载，因为服务器未响应。要重新加载图表，请 ` }
        <Link href={ window.document.location.href }>再次点击。</Link>
      </Text>

      <CloseButton
        alignSelf={{ base: 'flex-start', lg: 'center' }}
        ml="auto"
        onClick={ onClose }
      />
    </Alert>
  ) : null;
}

export default ChartsLoadingErrorAlert;
